import { FormikMultiUserPicker } from 'components/PersonPicker'
import { Field } from 'formik'
import { FormikCheckbox, FormikTextField } from 'formik-office-ui-fabric-react'
import { FieldStack, FieldStackItem, FormStack } from 'forms/FormStack'
import { MaintenanceAreaInsertInput } from 'gql.generated'
import { Box } from 'grid'
import { Label, Stack } from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'

export type MaintenanceFormValues = MaintenanceAreaInsertInput
export const MaintenanceForm: React.FC = () => {
  const { t } = useTranslation()

  return (
    <FormStack>
      <FieldStack>
        <FieldStackItem
          name="department"
          component={FormikTextField}
          label={t('Abteilung')}
        />
        <FieldStackItem
          name="maintenanceArea"
          component={FormikTextField}
          label={t('Meisterei')}
        />
        <Stack.Item className="composite-field">
          <Label>{t('Meister')}</Label>
          <Field name="maintenanceHead" component={FormikMultiUserPicker} />
        </Stack.Item>
        <FieldStackItem
          name="annotation"
          label={t('field.annotation.label')}
          multiline={true}
          rows={3}
          component={FormikTextField}
        />
        <FieldStackItem
          stack={{ grow: 0 }}
          name="inactive"
          render={(fieldProps) => (
            <>
              <Label>{t('field.inactive.label')}</Label>
              <Box py={1}>
                <FormikCheckbox {...fieldProps} />
              </Box>
            </>
          )}
        />
      </FieldStack>
    </FormStack>
  )
}
